import {
  Button,
  Container,
  Drawer,
  IconButton,
  List,
  ListItem,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import LogoIcon from "../../logo/LogoIcon";
import { useRouter } from "next/router";
import { useState } from "react";
import NextLink from "next/link";
import RegisterModal from "../../Modal/RegisterModal";
import SideNav from "./SideNav";
import { useAuthProvider } from "../../../context/AuthProvider";

const AuthNav = () => {
  let curl = useRouter();
  const [show, setShow] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const location = curl.pathname;

  const { clearState } = useAuthProvider();

  const routing = () => {
    switch (location) {
      case "/login":
        curl.push("/register");
        // setShow(true);
        break;
      case "/create-user":
        curl.push("/login");
        break;
      case "/register":
        curl.push("/login");
        break;
      case "/register/organization":
        curl.push("/login");
        break;
      case "/register/organization/onboarding":
        curl.push("/help/help-me");
        break;
      case "/reset":
        curl.push("/login");
        break;
      case "/reset/verification":
        curl.push("/login");
        break;
      case "/reset/password":
        curl.push("/login");
        break;
      default:
        break;
    }
  };

  const handleClose = () =>{
    setShowDrawer(false)
  }

  const buttonRoutes = [
    "/register",
    "/login",
    "/register/organization/onboarding",
    "/register/organization",
    "/create-user",
    "/register/verification",
    "/reset",
    "/reset/password",
    "/reset/verication",
  ];

  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("md"));

  if (!lgUp) {
    return (
      <Box
        sx={{
          width: "100%",
          paddingBottom: "4em",
          display: { xs: "block", sm: "block", md: "none" },
          paddingTop: "2em",
          px: "2em",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <img
            src="/iDonatio.png"
            style={{ marginRight: "1em", height: "2em" }}
          />
          <IconButton
            size="large"
            color="inherit"
            aria-label="menu"
            onClick={() => setShowDrawer(true)}
            sx={{
              display: {
                md: "none",
                xs: "flex",
              },
            }}
          >
            <i class="las la-bars la-sm" style={{ color: "blue" }}></i>
          </IconButton>
        </Box>
        <Drawer
          anchor="left"
          open={showDrawer}
          onClose={handleClose}
          variant="temporary"
          PaperProps={{
            sx: {
              width: "265px",
              border: "0 !important",
              pt: "2em",
              px: "1em",
              flexShrink: 0,
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <img src="/iDonatio.png" style={{ height: "2em" }} />
            <IconButton
              size="large"
              color="inherit"
              aria-label="menu"
              onClick={() => setShowDrawer(false)}
              sx={{
                display: {
                  md: "none",
                  xs: "flex",
                },
              }}
            >
              <i class="las la-times la-sm" style={{ color: "blue" }}></i>
            </IconButton>
          </Box>
          <List>
            <NextLink href="/" onClick={handleClose}>
              <ListItem
                button
                sx={{ justifyContent: "center", color: "primary" }}
              >
                Home
              </ListItem>
            </NextLink>
            <NextLink href="/about" onClick={handleClose}>
              <ListItem button href="/about" sx={{ justifyContent: "center" }}>
                About
              </ListItem>
            </NextLink>
            <NextLink href="/contact" onClick={handleClose}>
              <ListItem
                button
                href="/contact"
                sx={{ justifyContent: "center" }}
              >
                Contact us
              </ListItem>
            </NextLink>
            <NextLink href="/faq" onClick={handleClose}>
              <ListItem button href="/faq" sx={{ justifyContent: "center" }}>
                Faq
              </ListItem>
            </NextLink>
          </List>
          {location == "/register/organization/onboarding" ||
          location == "/register/verification" ? (
            <Button
              onClick={() => {
                sessionStorage.removeItem("reg");
                curl.replace("/login");
                clearState();
                handleClose()
              }}
              color="primary"
              sx={{
                textTransform: "none",
                background: "rgba(255, 255, 255, 0.8)",
                border: "1px solid #2962FF",
                borderRadius: "8px",
                mb: "1em",
              }}
            >
              Log out
            </Button>
          ) : null}

          {buttonRoutes.includes(location) && (
            <Button
              onClick={()=>{
                routing()
                handleClose()
              }}
              color="primary"
              startIcon={
                location == "/register/organization/onboarding" && (
                  <>
                    <i
                      class="las la-question-circle la-md"
                      style={{ color: "#2962FF" }}
                    ></i>
                  </>
                )
              }
              sx={{
                textTransform: "none",
                background: "rgba(255, 255, 255, 0.8)",
                border: "1px solid #2962FF",
                borderRadius: "8px",
              }}
            >
              {location == "/login"
                ? "Register"
                : location == "/register" ||
                  location == "/register/organization" ||
                  location == "/create-user" ||
                  location == "/reset" ||
                  location == "/reset/password" ||
                  location == "/reset/verication"
                ? "Login"
                : location == "/register/organization/onboarding" ||
                  location == "/register/verification"
                ? "Get help"
                : ""}
            </Button>
          )}
        </Drawer>
        <RegisterModal setShow={setShow} show={show} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        paddingBlock: "4em",
        display: { xs: "none", sm: "none", md: "block" },
      }}
    >
      <Container
        sx={{
          mx: "auto",
          display: "flex",
          justifyContent: "center",
          py: "0.5em",
          position: "relative",
        }}
      >
        {location == "/register/organization/onboarding" ||
        location == "/register/verification" ? (
          <Button
            onClick={() => {
              sessionStorage.removeItem("reg");
              clearState();
              curl.push("/login");
            }}
            color="primary"
            sx={{
              textTransform: "none",
              position: "absolute",
              left: "0",
              top: "20%",
              background: "rgba(255, 255, 255, 0.8)",
              border: "1px solid #2962FF",
              borderRadius: "8px",
              marginLeft: "2em",
            }}
          >
            Log out
          </Button>
        ) : null}
        {location == "/login" && (
          <Button
            onClick={() => {
              curl.push("/");
            }}
            color="primary"
            sx={{
              textTransform: "none",
              position: "absolute",
              left: "0",
              top: "20%",
              background: "rgba(255, 255, 255, 0.8)",
              border: "1px solid #2962FF",
              borderRadius: "8px",
              marginLeft: "2em",
            }}
          >
            Home
          </Button>
        )}
        <LogoIcon />
        {buttonRoutes.includes(location) && (
          <Button
            onClick={routing}
            color="primary"
            startIcon={
              location == "/register/organization/onboarding" && (
                <>
                  <i
                    class="las la-question-circle la-md"
                    style={{ color: "#2962FF" }}
                  ></i>
                </>
              )
            }
            sx={{
              textTransform: "none",
              position: "absolute",
              right: "0",
              top: "20%",
              background: "rgba(255, 255, 255, 0.8)",
              border: "1px solid #2962FF",
              borderRadius: "8px",
              marginRight: "2em",
            }}
          >
            {location == "/login"
              ? "Register"
              : location == "/register" ||
                location == "/register/organization" ||
                location == "/create-user" ||
                location == "/register" ||
                location == "/register/organization" ||
                location == "/create-user" ||
                location == "/reset" ||
                location == "/reset/password" ||
                location == "/reset/verication"
              ? "Login"
              : location == "/register/organization/onboarding" ||
                location == "/register/verification"
              ? "Get help"
              : ""} 
          </Button>
        )}
        {/* <RegisterModal setShow={setShow} show={show} /> */}
      </Container>
    </Box>
  );
};

export default AuthNav;
